import { App } from '@ps20-frontend/frontend-models';
import { EventHistoryItem } from './eventHistoryItem';
import { GlobalAction, GlobalActions } from './global-actions';
import { DoRequest } from './payload-models';

export class EventHistoryQueue {
  private readonly eventHistory: Array<EventHistoryItem> = [];
  private readonly maxSizeEventHistory = 100;

  private static generateEventHistoryItem(action: GlobalAction<{ appId?: App }>): EventHistoryItem {
    if (action.type === GlobalActions.DO_REQUEST) {
      const actionPayload = action.payload as DoRequest;
      return {
        appName: actionPayload.appId,
        eventName: action.type,
        data: actionPayload.url,
      };
    } else if (action.payload && action.payload.appId != null) {
      return { appName: action.payload.appId, eventName: action.type };
    }

    return { eventName: action.type };
  }

  addActionToEventHistory(action: GlobalAction<{ appId?: App }>): void {
    if (this.eventHistory.length < this.maxSizeEventHistory) {
      this.eventHistory.push(EventHistoryQueue.generateEventHistoryItem(action));
    } else {
      this.eventHistory.shift();
      this.eventHistory.push(EventHistoryQueue.generateEventHistoryItem(action));
    }
  }

  dumpHistory(): string {
    return JSON.stringify(this.eventHistory);
  }
}
